import { Box, Typography, useTheme } from "@mui/material";
// import dayjs from "dayjs";
import React from "react";
import HeaderTime from "./HeaderTime";
// import FingerprintIcon from "@mui/icons-material/Fingerprint";

const Clock: React.FC = (): React.ReactElement => {
  const theme = useTheme();

  // const label = dayjs().format("A") === "AM" ? "Clock In" : "Clock Out";
  return (
    <Box
      // variant="outlined"
      color="error"
      sx={{
        // borderRadius: 12,
        // border: "2px solid red",
        // py: 1,
        // px: 1,
        // width: "10em", // fixed width to prevent jumping
        width: "fit-content",
        // maxWidth: "14em",
        // gap: 1,
        textAlign: "center",
        whiteSpace: "nowrap", // prevents wrapping
        [theme.breakpoints.down("sm")]: {
          width: "9em" // slightly narrower on small screens
        }
      }}
    >
      {/* <FingerprintIcon
        fontSize="large"
        color="error"
        sx={{
          height: "fit-content",
        }}
      /> */}

      <Typography
        sx={{
          color: theme.palette.error.main,
          fontWeight: 500
        }}
      >
        {/* {label}{" "} */}
        <Box component="span" display="inline-flex" ml={0.5}>
          {/* this is the component of time  */}
          <HeaderTime />
        </Box>
      </Typography>
    </Box>
  );
};

export default React.memo(Clock);
